exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".backgroundColorsItem{display:block;border:2px solid #fff;border-radius:100%;width:22px;height:22px;border-radius:50%;float:left;cursor:pointer;margin-left:5px}.backgroundColorsItems{margin:0;list-style:none;display:inline-block;justify-content:center;padding:5px 0 6px;padding-bottom:15px}.bacgroundColorsComponent{width:100%;display:inline-block;text-align:center}.option-list{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8df79eca","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/BackgroundsColors/BackgroundColors.vue
// module id = 89
// module chunks = 0